"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _utils_1 = require("@utils");
const ArticleTeaserOverlap_1 = require("./ArticleTeaserOverlap"); // Component
var ArticleTeaserCorner = function ArticleTeaserCorner(_ref) {
    var eyebrowLabel = _ref.eyebrowLabel, title = _ref.title, description = _ref.description, url = _ref.url, heroImageUrl = _ref.heroImageUrl;
    return /*#__PURE__*/ react_1.default.createElement(StyledWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledImageSet, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledTeaserImage, {
        src: heroImageUrl,
        objectFit: "cover",
        widthClass: "bodyMargin",
        alt: title
    })), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.BoxShadow, null)), /*#__PURE__*/ react_1.default.createElement(StyledCopy, null, eyebrowLabel && /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "center"
    }, eyebrowLabel), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Header, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    }), /*#__PURE__*/ react_1.default.createElement(StyledSubhead, {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Rule, null), /*#__PURE__*/ react_1.default.createElement(StyledButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.StyledButton, {
        to: url,
        type: "black",
        shadow: true,
        size: "large"
    }, "Read more", /*#__PURE__*/ react_1.default.createElement("span", {
        className: "seoCopy"
    }, " about ", title)))), /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        to: url
    }, title));
};
var StyledWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Wrapper, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledWrapper",
    componentId: "sc-11wz3ng-0"
})(["", "{flex-direction:column !important;}", "{flex-direction:row-reverse !important;min-height:0 !important;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'));
var StyledImageSet = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageSet, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledImageSet",
    componentId: "sc-11wz3ng-1"
})(["", "{position:relative !important;width:100% !important;height:480px !important;}", "{position:absolute !important;left:0px !important;top:0 !important;width:724px !important;height:448px !important;}", "{width:880px !important;height:580px !important;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledTeaserImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.TeaserImage, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledTeaserImage",
    componentId: "sc-11wz3ng-2"
})(["", "{transform:scale3d(1.045,1.045,1) !important;transition:opacity 0.5s ease-in-out,transform 2s ease-in-out !important;", ":hover &{transform:scale3d(1,1,1) !important;}}"], _utils_1.mediaQuery('tablet'), StyledWrapper);
var StyledCopy = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Copy, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledCopy",
    componentId: "sc-11wz3ng-3"
})(["", "{width:600px !important;padding:40px 40px 0 40px !important;margin:-120px 0 0 0 !important;text-align:center !important;}", "{width:680px !important;padding-bottom:0 !important;margin:328px 0 0 0 !important;}", "{width:768px !important;padding-bottom:0 !important;margin:420px 0 0 0 !important;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledSubhead = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Subhead, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledSubhead",
    componentId: "sc-11wz3ng-4"
})(["", "{", ":hover &{transform:translate3d(0,4px,0) !important;}}"], _utils_1.mediaQuery('tablet'), StyledWrapper);
var StyledButtonWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ButtonWrapper, props);
}).withConfig({
    displayName: "ArticleTeaserCorner__StyledButtonWrapper",
    componentId: "sc-11wz3ng-5"
})(["", "{justify-content:center !important;}"], _utils_1.mediaQuery('tablet'));
exports.default = ArticleTeaserCorner;
